import { TextField } from "@mui/material";
import type { TextFieldProps } from "@mui/material";
import { inputStyles } from "../../utils/formStyles";

// Branded TextField component
export const BrandedTextField = (props: TextFieldProps) => {
  return (
    <TextField
      variant="standard"
      fullWidth
      sx={{
        ...inputStyles,
        ...props.sx,
      }}
      {...props}
    />
  );
};
